'use client'
import { useSearchType } from '@/api/hooks'
import { SectionHeader } from '@/components/sections'
import Toggle from '@/components/toggle'
import { SearchTypeContext } from '@/context/search-type'
import { setGADataLayer } from 'analytics'
import { useContext } from 'react'
import styled, { css } from 'styled-components'
import { desktop } from 'ui/src/css'
import TrendingIcon from '../icons/trending'
import { DeviceType } from '../util/env'
import { mobileSearchTypes, searchTypes } from './search/types'

const GridHeader = styled.div`
    ${desktop(css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    `)}
`

type Props = {
    children?: React.ReactNode
    deviceType: DeviceType
}

const HomeHeader = ({ children, deviceType }: Props) => {
    const { setTransitioning } = useContext(SearchTypeContext)
    const searchType = useSearchType()
    const isMobile = deviceType === 'mobile'

    return (
        <div className="mt-1 mb-2.5 flex flex-col gap-1.5 md:my-2.5 md:flex-col-reverse md:gap-2.5">
            <GridHeader>
                <SectionHeader
                    Icon={<TrendingIcon className="size-5" />}
                    label="Trending Now"
                    tag="h1"
                    className="hidden md:inline-block"
                />
                <Toggle
                    isMobile={isMobile}
                    className="w-full"
                    index={Math.max((isMobile ? mobileSearchTypes : searchTypes).indexOf(searchType || 'gifs'), 0)}
                    onClick={(index) => {
                        const nextType = (isMobile ? mobileSearchTypes : searchTypes)[index]
                        setTransitioning(nextType !== searchType)
                        setGADataLayer({
                            event: 'page_view',
                            options: {
                                pageType: 'home',
                                pageCategory: `homepage_${nextType}`,
                            },
                        })
                    }}
                    options={
                        isMobile
                            ? [
                                  { label: 'Trending', href: '/' },
                                  { label: 'Stickers', href: '/?type=stickers' },
                                  { label: 'Emoji', href: '/?type=emoji' },
                                  { label: 'Memes', href: '/?type=memes' },
                                  { label: 'Reactions', href: '/?type=reactions' },
                                  { label: 'Animals', href: '/?type=animals' },
                                  { label: 'Text', href: '/?type=text' },
                              ]
                            : [
                                  { label: 'GIFs', href: '/' },
                                  { label: 'Stickers', href: '/?type=stickers' },
                                  { label: 'Clips', href: '/?type=clips' },
                              ]
                    }
                />
            </GridHeader>
            {children}
        </div>
    )
}

export default HomeHeader
